import React from 'react'
import { Content } from '../../styled'
import TermsConditions from '../../../Pages/internal/TermsConditions'
import { withTranslation } from 'react-i18next'

const Terms = (props) => {
  const {
    t
  } = props
  return (
    <Content>
      <Content.Heading>{t('menu.terms_and_conditions')}</Content.Heading>
      <Content.Description>
        <TermsConditions />
      </Content.Description>
    </Content>
  )
}

export default withTranslation('help_center')(Terms)
